module.exports = __webpack_public_path__ + "static/Product_TVcurved1-db83271866dd5c64933acfa4748ccc86.png";